import { useFormContext } from 'react-hook-form';
import Label from '@/components/fields/Label';
import countriesList from '@/utils/countriesList.json';
import { ReactNode } from 'react';

export default function CountryField({
  id,
  children,
  isRequired,
  disabled,
}: {
  id: string;
  children: ReactNode;
  isRequired: boolean;
  disabled?: boolean;
}): JSX.Element {
  const { register, errors } = useFormContext();
  const hasErrors = typeof errors[id] !== 'undefined';

  return (
    <div className="mt-4 md:flex md:items-center">
      <div className="md:w-2/5 md:pr-4">
        <Label id={id} isRequired={isRequired}>
          {children}
        </Label>
      </div>
      <div className="md:w-2/5 md:pl-4">
        <select
          defaultValue=""
          id={id}
          name={id}
          className={`mt-2 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5 disabled:bg-gray-300 ${
            hasErrors ? 'border-red-600' : 'border-gray-300'
          }`}
          ref={register}
          disabled={disabled ? true : false}
        >
          <option value="" disabled>
            Select...
          </option>
          {countriesList.map(({ name, value }) => {
            return (
              <option key={value} value={value}>
                {name}
              </option>
            );
          })}
        </select>
        {hasErrors ? (
          <p className="mt-1 text-sm text-red-600">{errors[id].message}</p>
        ) : null}
      </div>
    </div>
  );
}
